/**
 * BedroomCount Value Object
 * 
 * Domain concept: "How many bedrooms does this property have?"
 * 
 * Business rules:
 * - Null bedrooms normalized to null (use hasValue to check)
 * 
 * Computed facts:
 * - hasValue: Whether bedroom count exists (not null)
 * 
 * Usage:
 * - Format: src/ui/bedrooms/format-bedrooms.ts
 * - UI: src/ui/stats/hero-stats.tsx
 */
export class BedroomCount {
  readonly #value: number | null;

  private constructor(value: number | null) {
    this.#value = value;
  }

  /**
   * Creates a BedroomCount from a numeric value.
   */
  static from(bedrooms: number | null | undefined): BedroomCount {
    return new BedroomCount(bedrooms ?? null);
  }

  /**
   * Returns the bedroom count
   */
  get value(): number | null {
    return this.#value;
  }

  /**
   * Checks if we have bedroom data (not null)
   */
  get hasValue(): boolean {
    return this.#value !== null;
  }
}
